import { render, staticRenderFns } from "./GameDetail.vue?vue&type=template&id=58dd5b06&scoped=true&"
import script from "./GameDetail.vue?vue&type=script&lang=js&"
export * from "./GameDetail.vue?vue&type=script&lang=js&"
import style0 from "./GameDetail.vue?vue&type=style&index=0&id=58dd5b06&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dd5b06",
  null
  
)

export default component.exports